import template from './companyBenefitModal.html';
import controller from './companyBenefitModal.controller';

let CompanyBenefitModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default CompanyBenefitModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/companyBenefitModal/companyBenefitModal.component.js